// RevenueOverview.jsx
import React from 'react';
import { Grid } from '@mui/material';
import RevenueCard from './RevenueCard';
import { feeRevenueData, subscriptionRevenueData, cardRevenueData } from '../../../mockData/accountingData';

const RevenueOverview = ({ filters }) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <RevenueCard
          title="Fee Revenue"
          data={feeRevenueData}
          filters={filters}
          chartType="bar"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <RevenueCard
          title="Subscription Revenue"
          data={subscriptionRevenueData}
          filters={filters}
          chartType="pie"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <RevenueCard
          title="Card Payment Revenue"
          data={cardRevenueData}
          filters={filters}
          chartType="bar"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <RevenueCard
          title="Bank Payment Revenue"
          data={cardRevenueData}
          filters={filters}
          chartType="bar"
        />
      </Grid>
    </Grid>
  );
};

export default RevenueOverview;